import { ISystemAccessLog } from 'interfaces';
import { BaseService } from './BaseService';

class SystemAccessLogService extends BaseService<ISystemAccessLog> {
  constructor() {
    super('access-logs');
  }
}

export const systemAccessLogService = new SystemAccessLogService();
